// STRY0289329 - Unlock More TxT Services Modal
// Vendors
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { push, replace } from 'connected-react-router';

// Components
import { Modal } from '../../modals';
import { ButtonPrimary } from 'texkit/dist/components/Buttons';
import { Trans } from '../../..';
import { LINK_SERVICES_STEPS } from '../../../../pages/LinkServicePage/LinkServiceSteps';
import { closeModal } from '../../../../reducers/modal/modalActions';

// Styles
import './unlock-more-txt-services-modal.scss';

const UnlockMoreTxTServicesModal = () => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector(state => state.language.selected);
  const navigatingToLink = useRef(false);

  const handleClose = () => {
    if (!navigatingToLink.current) {
      dispatch(replace('/'));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(closeModal('UnlockMoreTxTServicesModal'));
    };
  }, [dispatch]);

  const handleLinkMyDLID = () => {
    navigatingToLink.current = true;
    dispatch(
      closeModal('UnlockMoreTxTServicesModal', {
        onClose: () =>
          dispatch(push(`/link/${LINK_SERVICES_STEPS.STEP_UP_INTRO}/dpslr`)),
      })
    );
  };

  return (
    <Modal
      name="UnlockMoreTxTServicesModal"
      onClose={handleClose}
      className={`unlock-more-txt-services-modal ${
        selectedLanguage === 'es' ? 'unlock-more-txt-services-modal-es' : ''
      }`}
      disableOnClickOutside={true}
    >
      <h2 className="unlock-more-txt-services-modal-title">
        <Trans
          file="Modals"
          id="UnlockMoreTxTServices"
          fallback="Unlock more TxT services"
        />
      </h2>
      <p className="unlock-more-txt-services-modal-copy">
        <Trans
          file="Modals"
          id="UnlockMoreTxTServicesDescription"
          fallback=" Some services require a current Texas driver license or ID. Link yours
        to access more TxT services."
        />
      </p>
      <div className="unlock-more-txt-services-modal-actions">
        <ButtonPrimary
          type="button"
          className="unlock-more-txt-services-modal-cta"
          onClick={handleLinkMyDLID}
        >
          <Trans file="Labels" id="linkMyDLID" />
        </ButtonPrimary>
      </div>
    </Modal>
  );
};

export default UnlockMoreTxTServicesModal;